import { useI18n } from '@/hooks/useI18n';
import { IDIOMAS } from '@/i18n/idiomas';
import styles from './SelectorIdioma.module.css';

interface Props {
  /** `compacto` para las barras; `lista` para el panel móvil, donde hay sitio. */
  variante?: 'compacto' | 'lista';
  className?: string;
}

/**
 * Selector de idioma.
 *
 * Se dibuja recorriendo `IDIOMAS`: **agregar un idioma al registro lo hace
 * aparecer aquí sin tocar este archivo ni ninguno de los lugares donde se
 * monta.** Ese es el contrato que pidió el diseño.
 *
 * Grupo de botones y no un `<select>`: con dos o tres opciones caben en
 * pantalla, se ve cuál está activa sin desplegar nada, y un `<select>` nativo
 * no se puede vestir igual en los tres navegadores. Si algún día son cinco o
 * más, este componente se convierte en un menú y sigue siendo un solo archivo
 * el que cambia.
 */
export function SelectorIdioma({ variante = 'compacto', className }: Props) {
  const { idioma, cambiarIdioma, t } = useI18n();

  return (
    <div
      className={[styles[variante], className].filter(Boolean).join(' ')}
      role="group"
      aria-label={t.comun.idioma.selector}
    >
      {IDIOMAS.map((opcion) => (
        <button
          key={opcion.codigo}
          type="button"
          // `lang` en el botón para que el sintetizador de voz pronuncie
          // "English" en inglés y "Español" en español, y no al revés.
          lang={opcion.codigo}
          aria-pressed={opcion.codigo === idioma}
          onClick={() => cambiarIdioma(opcion.codigo)}
          className={styles.opcion}
        >
          {/* A la vista basta la abreviatura; quien usa lector de pantalla
              necesita el nombre completo y qué pasa al pulsar. */}
          <span aria-hidden="true">{opcion.corto}</span>
          <span className="ilu-sr-only">{t.comun.idioma.cambiarA(opcion.etiqueta)}</span>
        </button>
      ))}
    </div>
  );
}
